// Indlæses via Cookiebot (data-cookieconsent="preferences") - derfor ren JS uden jQuery, og localStorage kan kaste
const oneDayMs = 1000 * 60 * 60 * 24;

function initHidePreferences() {
    document.querySelectorAll(".alert-box__close").forEach((closeButton) => {
        closeButton.addEventListener("click", () => {
            try {
                localStorage.setItem("AlertClosed", "true");
                localStorage.setItem("AlertClosedTimeStamp", new Date().toString());
            } catch {
                // Uden storage vises boksen bare igen ved næste besøg
            }
        });
    });

    try {
        const closedTimeStamp = localStorage.getItem("AlertClosedTimeStamp");
        if (closedTimeStamp !== null && new Date() - new Date(closedTimeStamp) > oneDayMs) {
            localStorage.removeItem("AlertClosed");
            localStorage.removeItem("AlertClosedTimeStamp");
        }
    } catch {
        // Ingen storage - intet at rydde op
    }
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHidePreferences);
} else {
    initHidePreferences();
}
